"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeGridColumnShorthand = exports.openGridColumnShorthand = exports.closeGridRowShorthand = exports.openGridRowShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var getGridAxisShorthandParts = function (axis) {
    return [
        {
            prop: "grid-".concat(axis, "-start"),
            dataType: css_data_types_1.gridLineDataType,
            partOpener: (0, shorthand_parser_utils_1.splitShorthandOpener)(["grid-".concat(axis, "-start"), "grid-".concat(axis, "-end")]),
            multipleItems: true,
        },
        {
            prop: "grid-".concat(axis, "-end"),
            dataType: css_data_types_1.gridLineEndDataType,
            multipleItems: true,
            multipleSplit: true,
        },
    ];
};
var createGridAxisShorthandOpener = function (axis) {
    return function () {
        return (0, shorthand_parser_utils_1.createShorthandOpener)({
            prop: "grid-".concat(axis),
            parts: getGridAxisShorthandParts(axis),
            shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
        });
    };
};
var createGridAxisShorthandCloser = function (axis) {
    return function () {
        return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " / ", ""], ["", " / ", ""])), "grid-".concat(axis, "-start"), "grid-".concat(axis, "-end")));
    };
};
// grid-row
exports.openGridRowShorthand = createGridAxisShorthandOpener('row');
exports.closeGridRowShorthand = createGridAxisShorthandCloser('row');
// grid-column
exports.openGridColumnShorthand = createGridAxisShorthandOpener('column');
exports.closeGridColumnShorthand = createGridAxisShorthandCloser('column');
var templateObject_1;
//# sourceMappingURL=grid-axis-shorthand.js.map